import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Recos from 'components/productdetail/Recos';
import { getRecoSlotData, shouldRecosUpdate } from 'helpers/RecoUtils';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import { associatedProducts, associatedProductsHeading, centerRecos } from 'styles/components/productdetail/recosDetail.scss';

export class RecosDetail2 extends Component {

  // We don't want this component to re-render when it's either loading, or similarProductRecos haven't changed
  shouldComponentUpdate(nextProps) {
    return shouldRecosUpdate(this.props, nextProps);
  }

  render() {
    const { similarProductRecos = {}, onRecoClicked, heartsData } = this.props;
    // If we have recommendations, render the component.
    const { janus = {}, lastReceivedRecoKey } = similarProductRecos;
    const janusData = janus[lastReceivedRecoKey] || {};
    const janusRecos = getRecoSlotData(janusData['detail-vis-sims'], janusData['detail-2']);
    if (janusRecos) {
      const { title, recos } = janusRecos;
      return (
        <div className={cn(centerRecos, associatedProducts, associatedProductsHeading)}>
          <Recos
            id="alsoLike"
            recoType="associatedProducts"
            title={title}
            recos={recos}
            onRecoClicked={onRecoClicked}
            heartsData={heartsData} />
        </div>
      );
    }
    return null;
  }
}

RecosDetail2.propTypes = {
  styleId: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  similarProductRecos: PropTypes.object.isRequired
};

export default withErrorBoundary('RecosDetail2', RecosDetail2);
